import {
  AbstractController
} from "../../abstract/AbstractController";
import { UpdateWithdrawService, WithdrawService } from "./WithdrawService";

interface Children {
  processButton: HTMLElement | null;
  amountInputField: HTMLElement | null;
  resetButton: HTMLElement | null;
}

interface WithdrawControllerParams {
  apiEndpoint: string;
  actor: string;
  minWithdrawAmount: number;
  maxWithdrawAmount: number;
  onRequest?:()=>{};
  onSuccess?:()=>{};
  onFail?:()=>{};
  onUpdate?:(amount:number)=>{};
}

export class WithdrawController extends AbstractController {
  
  private withdrawService: WithdrawService;
  private updateWithdrawAmountService: UpdateWithdrawService;
  private withdrawAmount: number;

  constructor(
    public rootNode: HTMLElement | null,
    public params: WithdrawControllerParams,
    public children: Children
  ) {
    super(rootNode);
    if (!rootNode) throw new Error("No root node");

    this.withdrawService = new WithdrawService();
    this.updateWithdrawAmountService = new UpdateWithdrawService()
    this.bindEvents();
    this.updateComponent();
  }

  bindEvents(): void {
    if (!this.children.processButton)
      throw new Error("Missing processButton in children");

    this.children.processButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.params.onRequest?.call(null)
      this.withdrawService
        .call(this.params.apiEndpoint, {
          amount: this.withdrawAmount,
          actor: this.params.actor,
        })
        .then((withdrawResult) => {
          
          console.log (withdrawResult)
          this.updateWithdrawAmountService.call(this.params.apiEndpoint,{
            actor:this.params.actor
          }).then((updateResult)=>{


            if (updateResult.data){
              this.params.maxWithdrawAmount = updateResult.data.amount;
              this.params.onSuccess?.call(null)
              this.params.onUpdate?.call(null,updateResult.data.amount)
            }

          }).catch((e)=>{})
          
        });
    });

    if (!this.children.amountInputField)
      throw new Error("Missing amountInputField in children");

    this.children.amountInputField.addEventListener("change", (e) => {
      this.updateComponent();
    });

    if (!this.children.resetButton)
      throw new Error("Missing resetbutton in children");

    this.children.resetButton.addEventListener("click", (e) => {
        e.preventDefault();
      (this.children.amountInputField as HTMLFormElement).value =
        this.params.maxWithdrawAmount;
      this.updateComponent();
    });
  }

  private updateComponent() {
    this.withdrawAmount = parseFloat(
      (this.children.amountInputField as HTMLFormElement).value
    );
    (this.children.processButton as HTMLButtonElement).disabled =
      !this.isInWithdrawRange(
        this.withdrawAmount,
        this.params.minWithdrawAmount,
        this.params.maxWithdrawAmount
      );

    console.log(
      "change",
      !this.isInWithdrawRange(
        this.withdrawAmount,
        this.params.minWithdrawAmount,
        this.params.maxWithdrawAmount
      ),
      this.withdrawAmount,
      this.params.minWithdrawAmount,
      this.params.maxWithdrawAmount
    );
  }

  private isInWithdrawRange(
    amount: number,
    minWithdrawAmount: number,
    maxWithdrawAmount: number
  ): boolean {
    return (
      amount >= minWithdrawAmount &&
      amount <=  maxWithdrawAmount
    );
  }
}
